import { create } from 'zustand';

interface DocumentScrollState {
  rootDocumentId: number | null;
  activeSectionId: number | null;
  activeSectionCode: string | null;
  requestedScrollSectionId: number | null;
  requestedScrollNonce: number;
  setRoot: (rootDocumentId: number | null) => void;
  setActiveSection: (sectionId: number | null, sectionCode: string | null) => void;
  requestScrollTo: (sectionId: number) => void;
  clearScrollRequest: () => void;
}

export const useDocumentScrollStore = create<DocumentScrollState>((set) => ({
  rootDocumentId: null,
  activeSectionId: null,
  activeSectionCode: null,
  requestedScrollSectionId: null,
  requestedScrollNonce: 0,
  setRoot: (rootDocumentId) =>
    set((state) => {
      if (state.rootDocumentId === rootDocumentId) {
        return state;
      }
      return {
        rootDocumentId,
        activeSectionId: null,
        activeSectionCode: null,
        requestedScrollSectionId: null,
      };
    }),
  setActiveSection: (sectionId, sectionCode) =>
    set((state) => {
      if (state.activeSectionId === sectionId && state.activeSectionCode === sectionCode) {
        return state;
      }
      return { activeSectionId: sectionId, activeSectionCode: sectionCode };
    }),
  requestScrollTo: (sectionId) =>
    set((state) => ({
      requestedScrollSectionId: sectionId,
      requestedScrollNonce: state.requestedScrollNonce + 1,
    })),
  clearScrollRequest: () =>
    set((state) => {
      if (state.requestedScrollSectionId === null) {
        return state;
      }
      return { requestedScrollSectionId: null };
    }),
}));
